import React, { useState, useEffect } from 'react';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';

import application from 'application';
import serverInterface from 'server-interface';

import internalEventCodes from 'event-system/codes/internal';

import queryParameterNames from 'constants/query-parameter-names';

import {
  getActiveTagNames
} from 'root/startup-view/utilities';

import { ReactComponent as HashtagIcon } from 'assets/images/hashtag-icon.svg';

import './index.scss';

function TagsNavigator() {

  const location = useLocation();
  const [searchParameters, setSearchParameters] = useSearchParams();
  const navigate = useNavigate();

  const [rootState, setRootState] = useState({
    tags: [],
    selectedTag: null,
    loading: false
  });

  useEffect(function onLoad() {

    initialize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function initialize() {

    loadTags();

  }

  async function loadTags() {

    setRootState(function updateRootState(rootState) {
      return {
        ...rootState,
        loading: true
      };
    });

    const response = await serverInterface.startup.community.getTagsByCommunityId();

    setRootState(function updateRootState(rootState) {
      return {
        ...rootState,
        tags: response,
        loading: false
      };
    });

  }

  function onTagClick(tagName) {

    if (searchParameters.get('tags') === tagName) {
      navigate('/community');
    } else {
      navigate(`/community?tags=${tagName}`);
    }

  }

  function renderTag(option, index, activeTags) {

    let tagOptionClassName = 'tags-navigator-option';

    if (activeTags.indexOf(option.name) !== -1) {
      tagOptionClassName += ' selected';
    }

    const tagsOptionAttributes = {
      className: tagOptionClassName,
      href: `${location.pathname}?tags=${option.name}`,
      onClick(event) {
        event.preventDefault();
        onTagClick(option.name);
        return false;
      }
    };

    return <li className="tags-navigation-list-item" key={index} >
      <a{...tagsOptionAttributes}>

        <HashtagIcon className="tags-navigator-option-icon" />

        <p className='tags-navigator-option-name ellipsis'>{option.name}</p>

      </a>
    </li>;
  }

  function renderTags() {

    if (rootState.loading === true) {
      return;
    }

    const activeTags = getActiveTagNames(searchParameters);
    const tagsCount = rootState.tags.length;
    const elements = [];

    for (let index = 0; index < tagsCount; index++) {

      const option = rootState.tags[index];
      const tag = renderTag(option, index, activeTags);

      elements.push(tag);

    }

    const tagsListAttributes = {
      id: 'tags-navigator-list',
      className: 'helptap-list hide-scrollbar'
    };

    return <ul {...tagsListAttributes}>{elements}</ul>;

  }

  function renderSpinner() {

    if (rootState.loading === false) {
      return;
    }

    return <ht-spinner />;

  }

  function renderMain() {

    return (
      <div id="tags-navigator-main">
        {renderTags()}

        {renderSpinner()}
      </div>
    );

  }

  return renderMain();

}

export default TagsNavigator;